var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"email","d":"M27.444,13.889V5L43,20.556,27.444,36.111V27C16.333,27,8.556,30.556,3,38.333,5.222,27.222,11.889,16.111,27.444,13.889Z","transform":"translate(-3 -5)","fill":"#707070"}));
}

EmailInline.defaultProps = {"width":"40","height":"33.333","viewBox":"0 0 40 33.333"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
